import { RegistrationRouteImport } from './Import'
const {
    RoutesMap, InviteStudentList, AddInviteStudent,
    StudentInstituteEnrollmentList, AddStudentInstituteEnrollment, UpdateStudentInstituteEnrollment
} = RegistrationRouteImport

const RegistrationRoute = () => {
    return [
        {
            path: RoutesMap.INVITE_STUDENT_LIST.path,
            element: <InviteStudentList />
        },
        {
            path: RoutesMap.ADD_INVITE_STUDENT.path,
            element: <AddInviteStudent />
        },
        {
            path: RoutesMap.STUDENT_INSTITUTE_ENROLLMENT_LIST.path,
            element: <StudentInstituteEnrollmentList />
        },
        {
            path: RoutesMap.ADD_STUDENT_INSTITUTE_ENROLLMENT.path,
            element: <AddStudentInstituteEnrollment />
        },
        {
            path: RoutesMap.UPDATE_STUDENT_INSTITUTE_ENROLLMENT.path,
            element: <UpdateStudentInstituteEnrollment />
        },
    ]
}

export default RegistrationRoute;
